/* Reorder (signed-in) + recently-viewed (guest) section.
   Cart-add reuses the exact single-POST /cart/add.js -> cart:refresh ->
   drawer-open pattern already used by assets/quick-order.js's "Add all to
   cart" - not a new cart API call. Recently-viewed reads the localStorage
   key ("recently-viewed") already written by assets/pdp-b2b.js - not a
   second writer. */
if (!window.__homeReorder) {
  window.__homeReorder = true;

  document.addEventListener('DOMContentLoaded', function () {
    var reorderSection = document.querySelector('[data-reorder-section]');
    if (reorderSection) {
      reorderSection.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
        var input = stepper.querySelector('[data-qty-input]');
        stepper.querySelector('[data-qty-minus]').addEventListener('click', function () {
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        });
        stepper.querySelector('[data-qty-plus]').addEventListener('click', function () {
          input.value = (parseInt(input.value, 10) || 1) + 1;
        });
      });

      var addAllBtn = reorderSection.querySelector('[data-reorder-all]');
      if (addAllBtn) {
        addAllBtn.addEventListener('click', function () {
          var items = [];
          reorderSection.querySelectorAll('[data-variant-id]').forEach(function (li) {
            var qty = parseInt(li.querySelector('[data-qty-input]').value, 10) || 1;
            items.push({ id: parseInt(li.getAttribute('data-variant-id'), 10), quantity: qty });
          });
          if (!items.length) return;
          addAllBtn.disabled = true;
          var label = addAllBtn.textContent;
          addAllBtn.textContent = (window.b2bStrings || {}).adding || 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || 'add failed'); return data; }); })
            .then(function () {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              var drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.open === 'function') drawer.open();
              addAllBtn.textContent = (window.b2bStrings || {}).added || 'Added';
              setTimeout(function () { addAllBtn.textContent = label; addAllBtn.disabled = false; }, 1800);
            })
            .catch(function () {
              addAllBtn.textContent = (window.b2bStrings || {}).tryAgain || 'Try again';
              setTimeout(function () { addAllBtn.textContent = label; addAllBtn.disabled = false; }, 1800);
            });
        });
      }
      return;
    }

    var rvSection = document.querySelector('[data-recently-viewed-section]');
    if (!rvSection) return;
    try {
      var seen = JSON.parse(localStorage.getItem('recently-viewed') || '[]');
    } catch (e) {
      seen = [];
    }
    if (!seen.length) {
      /* Guest with no recently-viewed history: if the stock-up column also
         isn't present, the whole row has nothing left to show - hide the
         outer wrapper too, not just this column, so no empty section (with
         padding and a possible orphan heading) renders for this visitor. */
      var row = rvSection.closest('[data-reorder-row]');
      if (row && !row.querySelector('.home-reorder--stock-up')) {
        row.hidden = true;
      }
      return;
    }
    var list = rvSection.querySelector('[data-recently-viewed-list]');
    seen.slice(0, 8).forEach(function (item) {
      /* same card shape as the server-rendered stock-up tiles */
      var li = document.createElement('li');
      li.className = 'home-reorder__item';
      var media = document.createElement('a');
      media.className = 'home-reorder__media';
      media.href = item.url;
      media.tabIndex = -1;
      media.setAttribute('aria-hidden', 'true');
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 80;
        img.height = 80;
        img.className = 'home-reorder__thumb';
        media.appendChild(img);
      }
      li.appendChild(media);
      var body = document.createElement('div');
      body.className = 'home-reorder__body';
      if (item.brand) {
        var brand = document.createElement('span');
        brand.className = 'home-reorder__brand';
        brand.textContent = item.brand;
        body.appendChild(brand);
      }
      var title = document.createElement('a');
      title.className = 'home-reorder__title';
      title.href = item.url;
      title.textContent = item.title;
      body.appendChild(title);
      var buy = document.createElement('div');
      buy.className = 'home-reorder__buy';
      if (item.price) {
        var price = document.createElement('span');
        price.className = 'home-reorder__price';
        price.textContent = item.price;
        buy.appendChild(price);
      }
      var view = document.createElement('a');
      view.className = 'home-reorder__add home-reorder__add--link';
      view.href = item.url;
      view.textContent = rvSection.getAttribute('data-view-label') || 'View';
      buy.appendChild(view);
      body.appendChild(buy);
      li.appendChild(body);
      list.appendChild(li);
    });
    rvSection.hidden = false;
  });
}
